import { render, staticRenderFns } from "./diagnosis-item.vue?vue&type=template&id=4738874e&scoped=true"
import script from "./diagnosis-item.vue?vue&type=script&lang=js"
export * from "./diagnosis-item.vue?vue&type=script&lang=js"
import style0 from "./diagnosis-item.vue?vue&type=style&index=0&id=4738874e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738874e",
  null
  
)

export default component.exports